var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: {
          value: [],
          "item-key": "id",
          headers: _vm.headers,
          items: _vm.channels,
          "single-select": "",
        },
        on: { "click:row": (item) => _vm.$emit("onSelect", item) },
        scopedSlots: _vm._u(
          [
            {
              key: `item.channel`,
              fn: function ({ item }) {
                return [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(_vm._s(_vm.typeIcons[item.channel])),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t(`channels.${item.channel}`)) + " "
                  ),
                ]
              },
            },
            {
              key: `item.languages`,
              fn: function ({ item }) {
                return [
                  _c(
                    "v-chip",
                    {
                      attrs: {
                        color: "primary lighten-3",
                        "text-color": "white",
                        small: "",
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-web"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t(`languages.${_vm.getLanguage(item)}`)) +
                          " "
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: `item.action`,
              fn: function ({ item }) {
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.openEditDialog(item)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-pencil")])],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "550" },
          model: {
            value: _vm.editDialog,
            callback: function ($$v) {
              _vm.editDialog = $$v
            },
            expression: "editDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.$t("channelManagement.edit"))),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "editForm",
                      model: {
                        value: _vm.isFormValid,
                        callback: function ($$v) {
                          _vm.isFormValid = $$v
                        },
                        expression: "isFormValid",
                      },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t(
                            "channelManagement.createDialog.nameLabel"
                          ),
                          rules: _vm.rules.displayName,
                          autofocus: "",
                        },
                        model: {
                          value: _vm.displayName,
                          callback: function ($$v) {
                            _vm.displayName = $$v
                          },
                          expression: "displayName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { text: "" }, on: { click: _vm.closeEditDialog } },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: !_vm.isFormValid || !_vm.hasChanges(),
                      },
                      on: { click: _vm.updateChannel },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }